import React, {Component} from 'react'

class Help009 extends Component {
  constructor (props) {
    super(props)
    document.querySelector("meta[name='viewport']").setAttribute('content', 'width=1158px,shrink-to-fit=yes')
  }
  render () {
    return (
      <div className='container-fluid'>
        <div className='row-fluid'>
          <div className='span1' />
          <div className='span14 help-area'>
            <div className='page-header'>
              <h2><i className='icon-question-sign icon-large' />メール通知を受信しないように設定する</h2>
            </div>{/* ./page-header */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[9-1]</span>画面上部のメニューの中の「個人設定」の「通知受信可否設定変更」(図9-1 参照)を押してください。</legend>
              <figcaption>図9-1</figcaption>
              <ul>
                <li><img alt='' src='/help/help_9-1.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[9-2]</span>画面の中の「お知らせメール受信」の「受信しない」を押して、「通知受信可否設定を変更する」ボタン(図9-2 参照)を押してください。</legend>
              <figcaption>図9-2</figcaption>
              <ul>
                <li><img alt='' src='/help/help_9-2.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[9-3]</span>メッセージが表示されるので「OK」ボタンを押してください。(図9-3 参照)</legend>
              <figcaption>図9-3</figcaption>
              <ul>
                <li><img alt='' src='/help/help_9-3.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
          </div>{/* ./help-area */}
        </div>
      </div>
    )
  }
}

export default Help009



// WEBPACK FOOTER //
// ./src/help/Help009.js